export type PrivacySection = {
  heading: string;
  body: string | readonly string[];
};

export const privacySections: readonly PrivacySection[] = [
  {
    heading: "Who we are",
    body: "SpecOps Engineers LLC operates this website. This policy explains how we handle personal information when you use it.",
  },
  {
    heading: "Information we collect",
    body: "If you send a message through the contact form, we collect the name, email, optional company, and message you provide. We use basic spam protection on that form. We do not use advertising trackers, and we do not sell personal information.",
  },
  {
    heading: "How we use it",
    body: "We use contact form submissions to reply to you. Messages are delivered to our inbox. We keep them only as long as needed to handle your request and ordinary business records, then delete them.",
  },
  {
    heading: "GDPR",
    body: [
      "If you are in the European Economic Area, the United Kingdom, or Switzerland, we process contact form data to respond to your request and to keep the site secure (including stopping spam).",
      "Your information may be processed in the United States so we can receive and answer your message.",
      "You may ask us to access, correct, or delete personal information we hold about you; to restrict or object to certain processing; and, where the law allows, to receive a copy of data you provided. You may also complain to your local data protection authority. Use the contact form on this site to make a request. We will respond within the time the law requires.",
    ],
  },
  {
    heading: "California residents (CCPA / CPRA)",
    body: [
      "If you are a California resident, you have rights under the California Consumer Privacy Act as amended by the CPRA. From people who use the contact form, we collect identifiers such as name and email, plus whatever you choose to write in the company field or message.",
      "We use that information to reply to you and to run the site. We do not sell personal information. We do not share it for cross-context behavioral advertising.",
      "You may ask to know what we have collected, to delete it, or to correct inaccurate information, subject to legal exceptions. We will not treat you differently for exercising these rights. Send a request through the contact form and say you are a California resident. We will verify using the email you used and respond within the time the law allows.",
    ],
  },
  {
    heading: "Security",
    body: "We use HTTPS and access controls on administrative tools. No online transmission is perfectly secure. We take reasonable steps to protect your information.",
  },
  {
    heading: "Children",
    body: "This site is not directed at children under 16. We do not knowingly collect personal information from children.",
  },
  {
    heading: "Updates",
    body: "We may update this policy as the site changes. The effective date at the top of this page will change when we do.",
  },
];

export const privacyEffectiveDate = "August 4, 2026";
